import React, { useEffect, useState } from 'react';
import { AssetModel, CampaignModel as CampaignProps } from 'outbound-api-client/lib/models';
import { Button, Card, Content } from '../../components';
import { DealSummary } from '../OpportunityManagement';
import { DealSummarySection, PrizeSummarySection } from './Campaign.styles';
import { useNavigate, useParams } from 'react-router-dom';
import { configService } from '../../services';
import { LayoutType } from '../../services/config.service.types';
import { useCampaignDispatch } from './Campaigns.hooks';
import { useAppDispatch } from '../../store';
import { getAssets } from '../Assets/Assets.services';
import { Helmet } from 'react-helmet';
import '@fortawesome/fontawesome-free/css/all.min.css'
import { t } from 'i18next';

export const CampaignHome: React.FC<CampaignProps> = (props) => {
  const appId = process.env.REACT_APP_CLIENTID;

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { campaignId } = useParams();
  const { campaign } = useCampaignDispatch(dispatch, campaignId || '');
  const playbookUri = (!campaign) ? [] : campaign.contentUris.filter(c => /Playbook/i.test(c.identifier));

  // const downloadFile = (url: string, fileName?: string) => {
  //   fetch(url)
  //     .then((response) => response.blob())
  //     .then((blob) => {
  //       // Create a temporary URL for the blob
  //       const url = window.URL.createObjectURL(new Blob([blob]));
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setAttribute("download", fileName || ""); // Set the file name

  //       // Append to the document, click, and cleanup
  //       document.body.appendChild(link);
  //       link.click();
  //       link.parentNode?.removeChild(link);

  //       // Release the object URL to free memory
  //       window.URL.revokeObjectURL(url);
  //     })
  //     .catch((error) => console.error("Download failed:", error));
  // };

  const navigatePrizes = () => {
    navigate("article/Prize_Page_EN_GB");
  }



  const [isAssetLoaded, setIsAssetLoaded] = useState(false);
  // const [ing, setIsLoading] = useState(false);
  const [assets, setAssets] = useState<AssetModel[]>([]);



  useEffect(() => {
    if (campaignId && appId === "zebratechnologies") {

      setIsAssetLoaded(true);
      getAssets(campaignId)
        .then((assets) => {
          setAssets(assets);
        })
        .catch((err) => {
          // setHasError(true);
          setIsAssetLoaded(false);
        });
    }

  }, [campaignId, appId]);


  if (appId === "zebratechnologies") {

    if (campaign.identifier === null)
      return <div className="container-md py-5 text-center">
        <h1>{t("campaigns_notfound_heading")}</h1>
        <p dangerouslySetInnerHTML={{ __html: t("campaigns_notfound_subheading").replace("{id}", campaignId || "") }}></p>

        <a className='btn btn-dark' href='/'>{t("header_home")}</a>
      </div>

    const THUMBNAIL_WIDE = campaign?.contentUris.find(c => /THUMBNAIL_WIDE/i.test(c.type));
    return <>
      <Helmet>
        <title>{configService.current().applicationTitle} | {props.title}</title>
      </Helmet>
      {THUMBNAIL_WIDE?.uri && <img className='banner' src={THUMBNAIL_WIDE.uri} alt={props.title ?? undefined} />}
      <div className='container'>
        {assets && assets.length > 0 && <a className='btn btn-dark mb-3' href='#assets'>{t("button_assets")} <i className="fa-solid fa-chevron-right"></i></a>}
        <Content template={props.template} />
        {assets && assets.length > 0 && <div className='mt-5'>
          <h3>{t("header_assets")}</h3>
          <div id="assets" className='d-inline-block'>
            {/* <a className='d-block' href={t("cobranding_guide_url")} target='_blank' rel="noopener noreferrer">
              <i className="fa-solid fa-download"></i>
              {t("cobranding_guide_text")}
            </a> */}
            {assets.map((asset, inx) => {
              let assetName = asset.name;
              if (!assetName) {
                assetName = (decodeURIComponent(asset.fullUri).split('/').pop() || '').split('.')[0];
              }
              return <>
                <a key={`asset_${inx}`} className='d-block' href={asset.uri} target='_blank' rel="noopener noreferrer">
                  <i className="fa-solid fa-download"></i>
                  {assetName}
                </a>

                {/* <a key={`asset_${inx}`} href='#!' onClick={(e) => {
                  e.preventDefault();
                  downloadFile(asset.uri, assetName);
                }}> {assetName}</a> */}
              </>
            }
            )}
          </div>
        </div>}
        {/* <code><pre>{JSON.stringify(assets, null, 2)}</pre></code> */}
      </div >
    </>
  }





  return (
    <Card cssClasses='m-x-0' contentCSS='p-x-0 p-bottom-2' hideWrapper={configService.current().layoutType !== LayoutType.Legacy}>
      <h2 className="text-center font-title  m-bottom-0">{props.title}</h2>
      <div className='p-x-1'>
        {!!props.template?.length && (
          <Content template={props.template} />
        )}
      </div>
      <DealSummarySection>
        {configService.current().campaignProps.dealSummarySections.map((dealSummary) => {
          return <DealSummary mode={dealSummary.mode} title={dealSummary.title} logoUrl={dealSummary.logoUrl} oem={dealSummary.oem} playbookUrl={playbookUri[0].uri} borderColor={dealSummary.borderColour} />
        })}
      </DealSummarySection>

      {(configService.current().campaignProps.prizeSection.show) ?
        <PrizeSummarySection>
          <div
            className="prizes-prize-container">
            <div
              className="prize-description">
              <h3>{configService.current().campaignProps.prizeSection.title}</h3>
              <p>{configService.current().campaignProps.prizeSection.intro}</p>
              <Button primary onClick={navigatePrizes}>DISCOVER</Button>
            </div>
          </div>
        </PrizeSummarySection> : <></>}

    </Card>
  )
}